"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var customerNotification = __importStar(require("./modules/customerNotification/queries"));
var recordings = __importStar(require("./modules/recordings/queries"));
var decoder = __importStar(require("./modules/decoder/queries"));
exports.default = {
    customerNotification: customerNotification,
    recordings: recordings,
    decoder: decoder,
};
//# sourceMappingURL=queries.js.map